import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

import { PF } from '@app/pages/Warehouses/Brands/data';
import type { FiltersType } from '@app/pages/Warehouses/Brands/types';

const FILTERS = `${PF}_filters`;

export const Filters: FiltersType = ({
  unsavedValues: { SearchTerm },
  onChangeSearchTerm,
  skipSearchTerm,
  onSearch,
}) => (
  <div className={`${FILTERS}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название бренда"
      value={SearchTerm}
      onChange={onChangeSearchTerm}
      onPressEnter={onSearch}
      className={`${FILTERS}_search`}
    />
    <div className={`${FILTERS}_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipSearchTerm}
        className={`${FILTERS}_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${FILTERS}_buttons_item`}
      >
        Показать
      </Button>
    </div>
  </div>
);
